<template>
  <div class="container-contact">
    <div v-if="$slots.header" class="container-contact__header">
      <slot name="header">
      </slot>
    </div>
    <div class="container-contact__body">
      <slot>
        <CardInputRefactor
            ref="input-card"
            v-if="editMode && personToChange"
            v-model="personToChange"
            :config="config"
            :spr-data="sprData"
            @input="requestPersonUpdate($event)"
            :can-close-enter="canCloseEnter"
            :saving-data="savingData"
            @cancel="onCancel"
        />
        <div v-else>
          <CardInfo v-if="personInitial" :data="personToShow">
            <template #name="{row}">{{ row }}</template>
            <!--        <template #value="{row}">
                      {{ row.value != null ? (row.value && row.value.name != null ? row.value.name : row.value) : 'н/д' }}
                    </template>-->
          </CardInfo>
        </div>
      </slot>
    </div>
    <div class="container-contact__actions">
      <slot name="actions" :add="addContact" :loading="loadingContacts" :blocked="blocked" :canDeleted="canBeDeleted"
            :edit="changeEditaStatus" :delete="deleteContact">
        <v-btn v-if="!blocked && !isSingle" class="button white__v-btn mr-2" @click="addContact">
          Добавить новый контакт
        </v-btn>
        <v-btn v-if="!blocked" :loading="loadingContacts" class="button white__v-btn mr-2" @click="editMode = !editMode">
          {{ editMode ? 'Отменить': 'Редактировать' }}
        </v-btn>
        <template v-if="editMode">
          <v-btn
              :disabled="savingData"
              @click="sendData"
              @keyup.enter="sendData"
              :loading="savingData"
              :class="['white__v-btn mr-2']">
            Сохранить
          </v-btn>
        </template>
        <v-btn v-if="!blocked && canBeDeleted" class="button error__v-btn" @click="deleteContact">Удалить</v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
import CardInfo from '@/components/contacts/CardInfo';
import CardInputRefactor from "@/components/contacts/CardInput";

export default {
  components: {
    CardInputRefactor,
    CardInfo
  },
  name: 'ContainerPersonContact',
  props: {
    isSingle: {
      type: Boolean,
      default: false
    },
    sprData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    savingData: {
      type: Boolean,
      default: false
    },
    loadingContacts: {
      type: Boolean,
      default: false
    },
    blocked: {
      type: Boolean,
      default: false
    },
    canCloseEnter: {
      type: Boolean,
      default: true
    },
    canBeDeleted: {
      type: Boolean,
      default: true
    },
    contact: {
      type: Object,
      default: () => {
        return {
          region: null,
          category: null,
          organization: '',
          position: '',
          firstName: '',
          secondName: '',
          middleName: '',
          workPhoneNumber: '',
          email: ''
        }
      }
    },
    config: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      editMode: false,
      personToChange: null,
      personInitial: this.contact,
    }
  },
  watch: {
    // contact(newValue) {
    //   this.personToChange = this.initContactToChangeForm(newValue);
    //   this.personInitial = {...newValue};
    // },
    contact: {
      handler(newValue) {
        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
        this.personToChange = this.initContactToChangeForm(newValue);
        this.personInitial = {...newValue};
      },
      deep: true
    }
  },
  created() {
    this.personToChange = this.initContactToChangeForm(this.contact)
    if (this.blocked)
      this.editMode = false
  },
  computed: {
    personToShow() {
      let fullInfo = [];
      if (this.config) {
        this.config.forEach(el => {
          fullInfo.push({
            name: el.name,
            value: el.template ? el.template(this.contact[el.dataField]) : this.contact[el.dataField],
            cols: el.cols ? el.cols : 12
          })
        })
      } else {
        const {
          region,
          organization,
          category,
          firstName,
          secondName,
          middleName,
          position,
          workPhoneNumber,
          email
        } = this.contact;
        fullInfo = [
          {value: region?.subjectName, name: 'Субъект РФ'},
          {value: category, name: 'Категория'},
          {value: organization, name: 'Организация'},
          {value: position, name: 'Должность'},
          {value: firstName, name: 'Фамилия'},
          {value: secondName, name: 'Имя'},
          {value: middleName, name: 'Отчество'},
          {value: email, name: 'Контактный e-mail'},
          {value: workPhoneNumber, name: 'Телефон'},
        ]
      }
      return fullInfo
    },
  },
  methods: {
    addContact() {
      this.$emit('add-contact')
    },
    sendData(){
      this.$refs['input-card'].sendData()
    },
    changeEditaStatus() {
      this.editMode = !this.editMode
    },
    initContactToChangeForm(v) {
      const obj = {};
      for (const [key, value] of Object.entries(v)) {
        obj[key] = (typeof value === 'object') ? value?.id ?? value : value
      }
      return obj;
    },
    deleteContact() {
      this.$emit('delete-contact', this.contact)
    },
    async requestPersonUpdate(obj) {
      await this.$emit('change-contact', obj)
      this.editMode = false;
    },
    onCancel() {
      this.personToChange = this.initContactToChangeForm(this.contact);
      this.editMode = false;
    },
  },
}
</script>

<style lang="sass">
.info-card__button
  margin-top: 10px
  margin-left: 10px

.container-contact
  display: flex
  flex-direction: column
  max-width: 620px
  &__header
    padding: 17px 25px
    min-height: 96px
    font-family: 'Raleway', sans-serif
    font-style: normal
    font-weight: 600
    font-size: 17px
    line-height: 20px
    letter-spacing: 0.01em
    font-feature-settings: 'pnum' on, 'lnum' on
    color: #455A64
    border-bottom: 2px solid #EBEFF2
    @media (max-width: 1435px)
      min-height: 116px
    @media (max-width: 1106px)
      min-height: 135px
  &__body
    padding: 17px 25px 30px
  &__actions
    border-top: 2px solid #EBEFF2
    display: flex
    flex-direction: row
    justify-content: flex-start
    align-items: center
    padding: 25px
</style>